import i18n from 'i18next';

export function getCurrentLanguage() {
  return i18n.language ? i18n.language.split('-')[0] : 'en';
}
